import { Questions } from '../common-class/questions';
import { Answers } from '../common-class/answers';

export class CommonLogic {

    public static RandomQuestionsHandling(questions: Questions[]): Questions[] {
        let currentIndex = questions.length, temporaryValue, randomIndex ,subQnoinChar,subQnoinChar1;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;
            subQnoinChar=questions[currentIndex].subQnoinChar;
            subQnoinChar1=questions[randomIndex].subQnoinChar;
            // And swap it with the current element.
            temporaryValue = questions[currentIndex];
            questions[currentIndex] = questions[randomIndex];
            questions[currentIndex].subQnoinChar = subQnoinChar;
            questions[randomIndex] = temporaryValue;
            questions[randomIndex].subQnoinChar = subQnoinChar1;
        }

        return questions;
    }


    public static RotateQuestionsHandling(questions: Questions[]): Questions[] {
       let RotateIndex = questions[0].grpRotateIndex;
       for(let i = 0; i < RotateIndex; i++){
        questions.push(questions.shift());
        }
       
        return questions;
    }
    public static RandomQuestionsHandlingMatrixMobile(questions: [Questions[]]): [Questions[]] {
        let currentIndex = questions[0].length, temporaryValue, randomIndex 
        ,subQnoinChar,subQnoinChar1;
        
        while (0 !== currentIndex) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            questions.forEach(function (q) {
                subQnoinChar=q[currentIndex].subQnoinChar;
                subQnoinChar1=q[randomIndex].subQnoinChar;
                temporaryValue = q[currentIndex];
                q[currentIndex] = q[randomIndex];
                q[currentIndex].subQnoinChar = subQnoinChar;
                q[randomIndex] = temporaryValue;
                q[randomIndex].subQnoinChar = subQnoinChar1;
            });
        }
        return questions;
    }

    public static RandomAnswerHandling(questions: Questions): Answers[] {
        let currentIndex = questions.Answers.length, temporaryValue, randomIndex;
        let updateItem = questions.Answers.find(e => e.isOther);

        if (updateItem != undefined && updateItem != null) {
            currentIndex -= 1;
        }

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = questions.Answers[currentIndex];
            questions.Answers[currentIndex] = questions.Answers[randomIndex];
            questions.Answers[randomIndex] = temporaryValue;
        }

        return questions.Answers;
    }

    public static RandomQuestionsAnswerHandling(questions: Questions[]): Questions[] {
        let currentIndex = questions[0].Answers.length, questionslength = questions.length, temporaryValue, randomIndex;
        let updateItem; 
        
        // While there remain elements to shuffle...

        while (0 !== currentIndex) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            while (0 !== questionslength) {
                questionslength -= 1;
                updateItem = questions[questionslength].Answers.find(e => e.isOther);
                if (updateItem != undefined && updateItem != null) {
                    currentIndex -= 1;
                }

                temporaryValue = questions[questionslength].Answers[currentIndex];
                questions[questionslength].Answers[currentIndex] = questions[questionslength].Answers[randomIndex];
                questions[questionslength].Answers[randomIndex] = temporaryValue;
            }
        }

        return questions;
    }

    public static Convert_To_Alpha(intNumber: number): string{
        try {
            switch (intNumber) {
                case 1:
                    {
                        return "(a)";

                    }

                case 2:
                    {
                        return "(b)";

                    }

                case 3:
                    {
                        return "(c)";

                    }

                case 4:
                    {
                        return "(d)";

                    }

                case 5:
                    {
                        return "(e)";

                    }

                case 6:
                    {
                        return "(f)";

                    }

                case 7:
                    {
                        return "(g)";

                    }

                case 8:
                    {
                        return "(h)";

                    }

                case 9:
                    {
                        return "(i)";

                    }

                case 10:
                    {
                        return "(j)";

                    }

                case 11:
                    {
                        return "(k)";

                    }

                case 12:
                    {
                        return "(l)";

                    }

                case 13:
                    {
                        return "(m)";

                    }

                case 14:
                    {
                        return "(n)";

                    }

                case 15:
                    {
                        return "(o)";

                    }

                case 16:
                    {
                        return "(p)";

                    }

                case 17:
                    {
                        return "(q)";

                    }

                case 18:
                    {
                        return "(r)";

                    }

                case 19:
                    {
                        return "(s)";

                    }

                case 20:
                    {
                        return "(t)";

                    }

                case 21:
                    {
                        return "(u)";

                    }

                case 22:
                    {
                        return "(v)";

                    }

                case 23:
                    {
                        return "(w)";

                    }

                case 24:
                    {
                        return "(x)";

                    }

                case 25:
                    {
                        return "(y)";

                    }

                case 26:
                    {
                        return "(z)";

                    }

                case 27:
                    {
                        return "(aa)";

                    }

                case 28:
                    {
                        return "(ab)";

                    }

                case 29:
                    {
                        return "(ac)";

                    }

                case 30:
                    {
                        return "(ad)";

                    }

                case 31:
                    {
                        return "(ae)";

                    }

                case 32:
                    {
                        return "(af)";

                    }

                case 33:
                    {
                        return "(ag)";

                    }

                case 34:
                    {
                        return "(ah)";

                    }

                case 35:
                    {
                        return "(ai)";

                    }

                case 36:
                    {
                        return "(aj)";

                    }

                case 37:
                    {
                        return "(ak)";

                    }

                case 38:
                    {
                        return "(al)";

                    }

                case 39:
                    {
                        return "(am)";

                    }

                case 40:
                    {
                        return "(an)";

                    }

                case 41:
                    {
                        return "(ao)";

                    }

                case 42:
                    {
                        return "(ap)";

                    }

                case 43:
                    {
                        return "(aq)";

                    }

                case 44:
                    {
                        return "(ar)";

                    }

                case 45:
                    {
                        return "(as)";

                    }

                case 46:
                    {
                        return "(at)";

                    }

                case 47:
                    {
                        return "(au)";

                    }

                case 48:
                    {
                        return "(av)";

                    }

                case 49:
                    {
                        return "(aw)";

                    }

                case 50:
                    {
                        return "(ax)";

                    }

                case 51:
                    {
                        return "(ay)";

                    }

                case 52:
                    {
                        return "(az)";

                    }

                case 53:
                    {
                        return "(ba)";

                    }

                case 54:
                    {
                        return "(bb)";

                    }

                case 55:
                    {
                        return "(bc)";

                    }

                case 56:
                    {
                        return "(bd)";

                    }

                case 57:
                    {
                        return "(be)";

                    }

                case 58:
                    {
                        return "(bf)";

                    }

                case 59:
                    {
                        return "(bg)";

                    }

                case 60:
                    {
                        return "(bh)";

                    }

                case 61:
                    {
                        return "(bi)";

                    }

                case 62:
                    {
                        return "(bj)";

                    }

                case 63:
                    {
                        return "(bk)";

                    }

                case 64:
                    {
                        return "(bl)";

                    }

                case 65:
                    {
                        return "(bm)";

                    }

                case 66:
                    {
                        return "(bn)";

                    }

                case 67:
                    {
                        return "(bo)";

                    }

                case 68:
                    {
                        return "(bp)";

                    }

                case 69:
                    {
                        return "(bq)";

                    }

                case 70:
                    {
                        return "(br)";

                    }

                case 71:
                    {
                        return "(bs)";

                    }

                case 72:
                    {
                        return "(bt)";

                    }

                case 73:
                    {
                        return "(bu)";

                    }

                case 74:
                    {
                        return "(bv)";

                    }

                case 75:
                    {
                        return "(bw)";

                    }

                case 76:
                    {
                        return "(bx)";

                    }

                case 77:
                    {
                        return "(by)";

                    }

                case 78:
                    {
                        return "(bz)";

                    }

                case 79:
                    {
                        return "(ca)";

                    }

                case 80:
                    {
                        return "(cb)";

                    }

                case 81:
                    {
                        return "(cc)";

                    }

                case 82:
                    {
                        return "(cd)";

                    }

                case 83:
                    {
                        return "(ce)";

                    }

                case 84:
                    {
                        return "(cf)";

                    }

                case 85:
                    {
                        return "(cg)";

                    }

                case 86:
                    {
                        return "(ch)";

                    }

                case 87:
                    {
                        return "(ci)";

                    }

                case 88:
                    {
                        return "(cj)";

                    }

                case 89:
                    {
                        return "(ck)";

                    }

                case 90:
                    {
                        return "(cl)";

                    }

                case 91:
                    {
                        return "(cm)";

                    }

                case 92:
                    {
                        return "(cn)";

                    }

                case 93:
                    {
                        return "(co)";

                    }

                case 94:
                    {
                        return "(cp)";

                    }

                case 95:
                    {
                        return "(cq)";

                    }

                case 96:
                    {
                        return "(cr)";

                    }

                case 97:
                    {
                        return "(cs)";

                    }

                case 98:
                    {
                        return "(ct)";

                    }

                case 99:
                    {
                        return "(cu)";

                    }

                case 100:
                    {
                        return "(cv)";

                    }

                case 101:
                    {
                        return "(cw)";

                    }

                case 102:
                    {
                        return "(cx)";

                    }

                case 103:
                    {
                        return "(cy)";

                    }

                case 104:
                    {
                        return "(cz)";

                    }

                case 105:
                    {
                        return "(da)";

                    }

                case 106:
                    {
                        return "(db)";

                    }

                case 107:
                    {
                        return "(dc)";

                    }

                case 108:
                    {
                        return "(dd)";

                    }

                case 109:
                    {
                        return "(de)";

                    }

                case 110:
                    {
                        return "(df)";

                    }

                case 111:
                    {
                        return "(dg)";

                    }

                case 112:
                    {
                        return "(dh)";

                    }

                case 113:
                    {
                        return "(di)";

                    }

                case 114:
                    {
                        return "(dj)";

                    }

                case 115:
                    {
                        return "(dk)";

                    }

                case 116:
                    {
                        return "(dl)";

                    }

                case 117:
                    {
                        return "(dm)";

                    }

                case 118:
                    {
                        return "(dn)";

                    }

                case 119:
                    {
                        return "(do)";

                    }

                case 120:
                    {
                        return "(dp)";

                    }

                case 121:
                    {
                        return "(dq)";

                    }

                case 122:
                    {
                        return "(dr)";

                    }

                case 123:
                    {
                        return "(ds)";

                    }

                case 124:
                    {
                        return "(dt)";

                    }

                case 125:
                    {
                        return "(du)";

                    }

                case 126:
                    {
                        return "(dv)";

                    }

                case 127:
                    {
                        return "(dw)";

                    }

                case 128:
                    {
                        return "(dx)";

                    }

                case 129:
                    {
                        return "(dy)";

                    }

                case 130:
                    {
                        return "(dz)";

                    }

                case 131:
                    {
                        return "(ea)";

                    }

                case 132:
                    {
                        return "(eb)";

                    }

                case 133:
                    {
                        return "(ec)";

                    }

                case 134:
                    {
                        return "(ed)";

                    }

                case 135:
                    {
                        return "(ee)";

                    }

                case 136:
                    {
                        return "(ef)";

                    }

                case 137:
                    {
                        return "(eg)";

                    }

                case 138:
                    {
                        return "(eh)";

                    }

                case 139:
                    {
                        return "(ei)";

                    }

                case 140:
                    {
                        return "(ej)";

                    }

                case 141:
                    {
                        return "(ek)";

                    }

                case 142:
                    {
                        return "(el)";

                    }

                case 143:
                    {
                        return "(em)";

                    }

                case 144:
                    {
                        return "(en)";

                    }

                case 145:
                    {
                        return "(eo)";

                    }

                case 146:
                    {
                        return "(ep)";

                    }

                case 147:
                    {
                        return "(eq)";

                    }

                case 148:
                    {
                        return "(er)";

                    }

                case 149:
                    {
                        return "(es)";

                    }

                case 150:
                    {
                        return "(et)";

                    }

                default:
                    {
                        return "";

                    }
            }
        }
        catch
        {

            return "";
        }

    }

    public static MatrixListRandom(array: any) {
        var currentIndex = array.length, temporaryValue, randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    }
}
